import { render, staticRenderFns } from "./VlAddressFilter.vue?vue&type=template&id=3795c3ba&scoped=true&"
import script from "./VlAddressFilter.vue?vue&type=script&lang=js&"
export * from "./VlAddressFilter.vue?vue&type=script&lang=js&"
import style0 from "./VlAddressFilter.vue?vue&type=style&index=0&id=3795c3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3795c3ba",
  null
  
)

export default component.exports